(function ($) {
	$(document).on('click', '#load-more-posts', function () {
		var $btn = $(this);
		var currentPage = parseInt($btn.attr('data-current-page'), 10) || 1;
		var perPage = parseInt($btn.attr('data-per-page'), 10) || 20;
		var maxPages = parseInt($btn.attr('data-max-pages'), 10) || 1;

		if (currentPage >= maxPages) {
			$btn.prop('disabled', true).addClass('opacity-50');
			return;
		}

		$btn.prop('disabled', true).addClass('opacity-50');
		$btn.text('Ladataan…');

		// Подготавливаем данные для AJAX запроса
		var ajaxData = {
			action: 'suomi_load_more_posts',
			nonce: SuomiLoadMore.nonce,
			paged: currentPage + 1,
			per_page: perPage
		};

		// Добавляем параметры архива, если они есть
		if (SuomiLoadMore.archiveParams && Object.keys(SuomiLoadMore.archiveParams).length > 0) {
			$.extend(ajaxData, SuomiLoadMore.archiveParams);
		}

		$.ajax({
			url: SuomiLoadMore.ajaxUrl,
			type: 'POST',
			dataType: 'json',
			data: ajaxData
		})
		.done(function (resp) {
			if (resp && resp.success && resp.data && resp.data.html) {
				$('#posts-list').append(resp.data.html);
				var newPage = currentPage + 1;
				$btn.attr('data-current-page', newPage);
				if (resp.data.has_more === false || newPage >= maxPages) {
					$btn.remove();
				} else {
					$btn.text('Katso lisää').prop('disabled', false).removeClass('opacity-50');
				}
			} else {
				$btn.remove();
			}
		})
		.fail(function () {
			$btn.text('Virhe').addClass('bg-red-600');
		})
		.always(function () {
			// if not removed and not enabled already
			if ($btn.is(':visible') && $btn.text() !== 'Katso lisää') {
				$btn.text('Katso lisää').prop('disabled', false).removeClass('opacity-50');
			}
		});
	});
})(jQuery);


